import React from "react"

import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"

import SourceStatusButton from "../../../sources/SourceStatusButton"

const NotificationViewItemDetails = ({
    title,
    message,
    send_push,
    isFetching,
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />
                Title
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={30}
                maxLineLength={60}
            >
                <p>{title || "No title"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-description" />
                Message
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={1}
                maxLines={2}
            >
                <p>{message || "No message"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-notification" />
                Push notifications
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1} tagLength={20}>
                <SourceStatusButton active={send_push}>
                    {send_push ? "On" : "Off"}
                </SourceStatusButton>
            </ContentLoaderTags>
        </div>
    </div>
)

export default NotificationViewItemDetails
